import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VehiculoGeocerca, DispositivoGeocerca } from './../../../_entities/geocerca/vehiculo-geocerca';
import {AuthService} from '../../auth/auth.service';
import {Categorias} from '../../../_entities/geocerca/Categorias';

@Injectable({
	providedIn: 'root'
})
export class GeocercasService {

	constructor(private http: HttpClient, private auth: AuthService) { }

	postGeoCerca(form: any): Observable<any> {
		return this.http.post<any>(`${environment.API_SECURITY}/api/geocercas`, form);
	}

	putGeoCerca(form: any, id: any): Observable<any> {
		return this.http.put<any>(`${environment.API_SECURITY}/api/geocercas/${id}`, form);
	}

	public getGeoCercas() {
		return this.http.get(`${environment.API_SECURITY}/api/geocercas`);
	}

	deleteGeoCerca(id: any) {
		return this.http.delete(`${environment.API_SECURITY}/api/geocercas/${id}`);
	}

	obtenerListaProductos(): Observable<DispositivoGeocerca[]> {
		return this.http.get<DispositivoGeocerca[]>(environment.API_SECURITY + '/api/Geocercas/ListaProductosGeocerca');
	}

	obtenerHistoricoGeocerca(listaIds, fechaInicio, fechaFinal) {
		return this.http.post(environment.API_SECURITY + '/api/Geocercas/ReporteFueraGeocerca', listaIds, {
			params: { fechaInicio, fechaFinal }
		});

	}

	obtenerVehiculosDentroGeocerca(fechaInicio, fechaFinal): Observable<VehiculoGeocerca[]> { // Solo estaran vehiculosDentro
		return this.http.get<VehiculoGeocerca[]>(environment.API_SECURITY + '/api/Geocercas/VehiculosDentroGeocerca', {
			params: {
				fechaInicio,
				fechaFinal
			}
		});
	}

	obtenerVehiculosFueraGeocerca(fechaInicio, fechaFinal): Observable<VehiculoGeocerca[]> {
		return this.http.get<VehiculoGeocerca[]>(environment.API_SECURITY + '/api/Geocercas/VehiculosFueraGeocerca', {
			params: {
				fechaInicio,
				fechaFinal
			}
		});
	}


	obtenerDentroGeocercaVehiculos(vehiculos, idGeocerca, fechaInicio, fechaFinal): Observable<VehiculoGeocerca[]> {
		return this.http.post<VehiculoGeocerca[]>(environment.API_SECURITY + '/api/Geocercas/VehiculoFueraGeocercaId/' + idGeocerca, vehiculos, {
			params: {
				fechaInicio,
				fechaFinal
			}
		});
	}

	obtenerFueraGeocercaVehiculos(vehiculos, idGeocerca, fechaInicio, fechaFinal): Observable<VehiculoGeocerca[]> {
		return this.http.post<VehiculoGeocerca[]>(environment.API_SECURITY + '/api/Geocercas/VehiculoDentroGeocercaId/' + idGeocerca, vehiculos, {
			params: {
				fechaInicio,
				fechaFinal
			}
		});
	}

	obtenerVehiculoDentroGeocerca(idVehiculo, idGeocerca, fechaInicio, fechaFinal): Observable<VehiculoGeocerca[]> {
		return this.http.get<VehiculoGeocerca[]>(`${environment.API_SECURITY}/api/Geocercas/VehiculoDentroGeocercaId/${idVehiculo}/${idGeocerca}`, {
			params: {
				fechaInicio,
				fechaFinal
			}
		});
	}

	obtenerVehiculoFueraGeocerca(idVehiculo, idGeocerca, fechaInicio, fechaFinal): Observable<VehiculoGeocerca[]> {
		return this.http.get<VehiculoGeocerca[]>(`${environment.API_SECURITY}/api/Geocercas/VehiculoFueraGeocercaId/${idVehiculo}/${idGeocerca}`, {
			params: {
				fechaInicio,
				fechaFinal
			}
		})
	}

	obtenerCategorias(): Observable<Categorias[]>{
		return this.http.get<Categorias[]>(environment.API_SECURITY + '/api/Geocercas/ObtenerCategorias');
	}

	emailAlertaPuerta(hwToken) {
		let user = this.auth.getUser();
		let token = '0'
		if(user.id == 'c28df0c4-3322-421c-b601-8aa7e80536cf'  || user.id == '74bc5a50-65cd-4fa3-9a68-99886b468b6b') {
			token = hwToken
		}

		return this.http.get(environment.API_SECURITY + '/api/Howen/EmailAlarma?token=' + hwToken);
	}

	emailZonaPeligrosa(hwToken) {
		let user = this.auth.getUser();
		let token = '0'
		if(user.id == 'c28df0c4-3322-421c-b601-8aa7e80536cf'  || user.id == '74bc5a50-65cd-4fa3-9a68-99886b468b6b') {
			token = hwToken
		}
		return this.http.get(environment.API_SECURITY + '/api/Howen/Email?token=' + hwToken);
	}

}
